import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

export default class ImageViewer extends React.Component {
    state = {
        scale: 100,
        currentScale: 100,
        docHistoryDropdownOpen: false, // documents history
    };

    componentDidMount() {
        // console.log('ImageViewer componentDidMount', this.image);
        setTimeout(() => {
            let orWidth = this.image.naturalWidth;
            let scale = this.image.width / orWidth;
            this.setState({ currentScale: scale });
            // console.log('ImageViewer componentDidMount', orWidth, scale);
            window.myImage = this.image;
        }, 200);
    }

    rotateClockwise = () => {
        // console.log('ImageViewer rotateClockwise');
    };

    rotateCounterClockwise = () => {
        // console.log('ImageViewer rotateCounterClockwise');
    };

    /**
     *  Zoom in handler todo min max zoom
     */
    zoomIn = () => {
        // console.log('DocumentViewer zoomIn', this.state.scale);
        if (this.state.scale < 400) {
            // this.state.scale = Math.round10(this.state.scale + 0.2, -1);
            let scale = Math.round10(this.state.scale + 20);
            this.setState({ scale });
        }
    };

    /**
     * Zoom out handler todo min max zoom
     */
    zoomOut = () => {
        // console.log('DocumentViewer zoomOut', this.state.scale);
        if (this.state.scale > 30) {
            // this.state.scale = Math.round10(this.state.scale - 0.2, -1);
            let scale = Math.round10(this.state.scale - 20);
            this.setState({ scale });
        }
    };

    onCloseViewer = () => {
        if (this.props.onClose) this.props.onClose();
    };

    toggleHistoryDropdown = () => {
        this.setState({
            docHistoryDropdownOpen: !this.state.docHistoryDropdownOpen,
        });
    };

    getNameById(id) {
        switch (id) {
            case 2:
                return 'Governance';
            case 6:
                return 'Agenda';
            default:
                return 'Votes';
        }
    }

    onClickPrevious = item => {
        // console.log('ImageViewer onClickPrevious', item);
        if (this.props.onClose) this.props.onClose();
        if (this.props.onClickPrevious) this.props.onClickPrevious(item);
    };

    onCloseViewerGovernance = () => {
        // console.log('DocumentViewerAnnotate onCloseViewerGovernance');
        if (this.props.onClickGovernance) this.props.onClickGovernance();
    };

    renderGovernanceButton = () => {
        // check for docTypeId ()
        // console.log('DocumentViewerAnnotate renderGovernanceButton', state.documents.currentDocument.docTypeId);
        if (!this.props.governanceButton) return null;
        return (
            this.props.fullScreen && (
                <div>
                    <button
                        onClick={this.onCloseViewerGovernance}
                        className="btp-pdf-viewer-buttons"
                        title="Close viewer"
                    >
                        Governance
                    </button>
                </div>
            )
        );
    };

    getPreviousDocs = () => {
        if (this.props.previousDocs) {
            return (
                <DropdownMenu>
                    <div className="recent-label text-muted">Recent</div>
                    {this.props.previousDocs.reverse().map((item, i) => {
                        return (
                            <DropdownItem key={i} onClick={this.onClickPrevious.bind(this, item)}>
                                <div>
                                    {item.fileName}
                                    <div style={{ fontSize: '0.8rem', color: 'lightgrey' }}>
                                        From the {this.getNameById(item.docTypeId)}
                                    </div>
                                </div>
                            </DropdownItem>
                        );
                    })}
                </DropdownMenu>
            );
        }
    };

    renderToolbar() {
        return (
            <div className="my-toolbar d-flex justify-content-between" id="pdf-viewer-toolbar">
                <div>
                    <Dropdown
                        className="file-name-dropdown"
                        isOpen={this.state.docHistoryDropdownOpen}
                        toggle={this.toggleHistoryDropdown}
                    >
                        <DropdownToggle caret>{this.props.fileName}</DropdownToggle>
                        {this.getPreviousDocs()}
                    </Dropdown>
                </div>
                <div className="my-toolbar-middle">
                    <button
                        className="btp-pdf-viewer-buttons"
                        title="Rotate Counter Clockwise"
                        onClick={this.rotateCounterClockwise}
                    >
                        <i className="fa fa-undo" aria-hidden="true" />
                    </button>
                    <button
                        className="btp-pdf-viewer-buttons"
                        title="Rotate Clockwise"
                        onClick={this.rotateClockwise}
                    >
                        <i className="fa fa-repeat" aria-hidden="true" />
                    </button>
                    <div className="btp-pdf-viewer-buttons-block">
                        <button
                            className="btp-pdf-viewer-button-in-block"
                            title="Zoom out"
                            onClick={this.zoomOut}
                        >
                            <i className="fa fa-search-minus" aria-hidden="true" />
                        </button>
                        <span className="btp-pdf-viewer-zoom text-muted">
                            {Math.round(this.state.scale * this.state.currentScale)}%
                        </span>
                        <button
                            className="btp-pdf-viewer-button-in-block"
                            title="Zoom in"
                            onClick={this.zoomIn}
                        >
                            <i className="fa fa-search-plus" aria-hidden="true" />
                        </button>
                    </div>
                </div>
                <div className="d-flex flex-nowrap">
                    {this.renderGovernanceButton()}
                    <div>
                        <button
                            onClick={this.onCloseViewer}
                            className="btp-pdf-viewer-buttons"
                            title="Close viewer"
                        >
                            <i className="fa fa-times" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { blob, fileName } = this.props;

        return (
            <div className="image-viewer-wrapper">
                {this.renderToolbar()}
                <div className="image-viewer-content">
                    <img
                        ref={el => (this.image = el)}
                        style={{
                            width: `${this.state.scale}%`,
                            height: `${this.state.scale}%`,
                        }}
                        className="image-viewer-img d-flex mx-auto"
                        src={blob}
                        alt={fileName}
                    />
                </div>
            </div>
        );
    }
}

ImageViewer.propTypes = {
    blob: PropTypes.string.isRequired,
    fileName: PropTypes.string,
    onClose: PropTypes.func,
    previousDocs: PropTypes.arrayOf(PropTypes.shape({})),
    onClickPrevious: PropTypes.func,
    governanceButton: PropTypes.bool,
};

ImageViewer.defaultProps = {
    previousDocs: [],
    onClickPrevious: null,
    governanceButton: false,
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/ImageViewer.js